import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  align-items: center;
`;

export const Body = styled.div`
  flex-direction: column;
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 1.56rem;

  padding: 0 1.56rem;

  & .input__search-actions {
    margin-right: 0;
    margin-bottom: 2rem;
  }
`;

export const HeaderList = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  padding: 25px 20px;
  margin-bottom: 3px;
  justify-content: space-between;
  background: linear-gradient(
    to bottom,
    ${props => props.theme.background} 0%,
    ${props => props.theme.background} 90%,
    transparent 100%
  );
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 2.44rem;
`;

export const Attendiment = styled.div`
  width: 25px;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 10px;
`;

export const LockScroll = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 11;
`;
